import { fork, call, put, takeEvery, takeLatest } from 'redux-saga/effects'
import myLibrarySaga from '../components/mylibrary/sagas/myLibrarySaga'
import userManagementSaga from "../components/userManagement/sagas/userManagementSaga";
import contentRequestSaga from "../components/content-request/sagas/contentRequestSagas";
import courseManagementSaga from '../components/course-Management/saga/courseManagementSaga';
import authSaga from '../components/login/sagas/authSaga';

function* watcherSaga() {
    yield fork(myLibrarySaga)
    yield fork(userManagementSaga)
    yield fork(contentRequestSaga)
    yield fork(courseManagementSaga)
    yield fork(authSaga)
}

  export default watcherSaga